// @core/api/endpoints/project/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { AddItem } from './add_item';
import { AddItemToComponent } from './add_item_to_component';
import { AddItemToEpic } from './add_item_to_epic';
import { AddItemToSprint } from './add_item_to_sprint';
import { AddProjectMember } from './add_project_member';
import { ArchiveProject } from './archive_project';
import { BulkMoveItems } from './bulk_move_items';
import { CloneProject } from './clone_project';
import { CloneSprint } from './clone_sprint';
import { CompleteSprint } from './complete_sprint';
import { CreateBoard } from './create_board';
import { CreateComponent } from './create_component';
import { CreateEpic } from './create_epic';
import { CreateLabel } from './create_label';
import { CreateMilestone } from './create_milestone';
import { CreateProject } from './create_project';
import { CreateSavedView } from './create_saved_view';
import { CreateSprint } from './create_sprint';
import { DeleteBoard } from './delete_board';
import { DeleteComponent } from './delete_component';
import { DeleteEpic } from './delete_epic';
import { DeleteLabel } from './delete_label';
import { DeleteMilestone } from './delete_milestone';
import { DeleteProject } from './delete_project';
import { DeleteSavedView } from './delete_saved_view';
import { DeleteSprint } from './delete_sprint';
import { GetBoard } from './get_board';
import { GetBoardView } from './get_board_view';
import { GetComponent } from './get_component';
import { GetCumulativeFlow } from './get_cumulative_flow';
import { GetEpic } from './get_epic';
import { GetItem } from './get_item';
import { GetItemByKey } from './get_item_by_key';
import { GetProject } from './get_project';
import { GetProjectStats } from './get_project_stats';
import { GetProjectSummary } from './get_project_summary';
import { GetSprint } from './get_sprint';
import { GetSprintBurndown } from './get_sprint_burndown';
import { GetTimeline } from './get_timeline';
import { GetVelocity } from './get_velocity';
import { ListBoards } from './list_boards';
import { ListComponents } from './list_components';
import { ListEpics } from './list_epics';
import { ListItems } from './list_items';
import { ListLabels } from './list_labels';
import { ListMilestones } from './list_milestones';
import { ListProjectMembers } from './list_project_members';
import { ListProjects } from './list_projects';
import { ListSavedViews } from './list_saved_views';
import { ListSprints } from './list_sprints';
import { MoveItem } from './move_item';
import { RemoveItem } from './remove_item';
import { RemoveItemFromComponent } from './remove_item_from_component';
import { RemoveItemFromEpic } from './remove_item_from_epic';
import { RemoveItemFromSprint } from './remove_item_from_sprint';
import { RemoveProjectMember } from './remove_project_member';
import { ResolveItemKey } from './resolve_item_key';
import { RestoreProject } from './restore_project';
import { StartSprint } from './start_sprint';
import { UpdateBoard } from './update_board';
import { UpdateComponent } from './update_component';
import { UpdateEpic } from './update_epic';
import { UpdateItem } from './update_item';
import { UpdateLabel } from './update_label';
import { UpdateMilestone } from './update_milestone';
import { UpdateProject } from './update_project';
import { UpdateProjectMemberRole } from './update_project_member_role';
import { UpdateSavedView } from './update_saved_view';
import { UpdateSprint } from './update_sprint';

// Re-export individual endpoints
export {
  AddItem,
  AddItemToComponent,
  AddItemToEpic,
  AddItemToSprint,
  AddProjectMember,
  ArchiveProject,
  BulkMoveItems,
  CloneProject,
  CloneSprint,
  CompleteSprint,
  CreateBoard,
  CreateComponent,
  CreateEpic,
  CreateLabel,
  CreateMilestone,
  CreateProject,
  CreateSavedView,
  CreateSprint,
  DeleteBoard,
  DeleteComponent,
  DeleteEpic,
  DeleteLabel,
  DeleteMilestone,
  DeleteProject,
  DeleteSavedView,
  DeleteSprint,
  GetBoard,
  GetBoardView,
  GetComponent,
  GetCumulativeFlow,
  GetEpic,
  GetItem,
  GetItemByKey,
  GetProject,
  GetProjectStats,
  GetProjectSummary,
  GetSprint,
  GetSprintBurndown,
  GetTimeline,
  GetVelocity,
  ListBoards,
  ListComponents,
  ListEpics,
  ListItems,
  ListLabels,
  ListMilestones,
  ListProjectMembers,
  ListProjects,
  ListSavedViews,
  ListSprints,
  MoveItem,
  RemoveItem,
  RemoveItemFromComponent,
  RemoveItemFromEpic,
  RemoveItemFromSprint,
  RemoveProjectMember,
  ResolveItemKey,
  RestoreProject,
  StartSprint,
  UpdateBoard,
  UpdateComponent,
  UpdateEpic,
  UpdateItem,
  UpdateLabel,
  UpdateMilestone,
  UpdateProject,
  UpdateProjectMemberRole,
  UpdateSavedView,
  UpdateSprint,
};

// Namespace export for convenient usage
export const projectApi = {
  AddItem,
  AddItemToComponent,
  AddItemToEpic,
  AddItemToSprint,
  AddProjectMember,
  ArchiveProject,
  BulkMoveItems,
  CloneProject,
  CloneSprint,
  CompleteSprint,
  CreateBoard,
  CreateComponent,
  CreateEpic,
  CreateLabel,
  CreateMilestone,
  CreateProject,
  CreateSavedView,
  CreateSprint,
  DeleteBoard,
  DeleteComponent,
  DeleteEpic,
  DeleteLabel,
  DeleteMilestone,
  DeleteProject,
  DeleteSavedView,
  DeleteSprint,
  GetBoard,
  GetBoardView,
  GetComponent,
  GetCumulativeFlow,
  GetEpic,
  GetItem,
  GetItemByKey,
  GetProject,
  GetProjectStats,
  GetProjectSummary,
  GetSprint,
  GetSprintBurndown,
  GetTimeline,
  GetVelocity,
  ListBoards,
  ListComponents,
  ListEpics,
  ListItems,
  ListLabels,
  ListMilestones,
  ListProjectMembers,
  ListProjects,
  ListSavedViews,
  ListSprints,
  MoveItem,
  RemoveItem,
  RemoveItemFromComponent,
  RemoveItemFromEpic,
  RemoveItemFromSprint,
  RemoveProjectMember,
  ResolveItemKey,
  RestoreProject,
  StartSprint,
  UpdateBoard,
  UpdateComponent,
  UpdateEpic,
  UpdateItem,
  UpdateLabel,
  UpdateMilestone,
  UpdateProject,
  UpdateProjectMemberRole,
  UpdateSavedView,
  UpdateSprint,
};
